import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormControl, Typography} from '@material-ui/core/';
import {campaignSelectCampaign} from '../../selectors/campaignSelector';
import CampaignInput from "./CampaignInput";

const CampaignReferenceField = ({campaign, field, label, options, optionText = 'name'}) => {
    if (!campaign.hasOwnProperty(field)) {
        return (<span/>);
    }

    if (!options.data || options.data.loaded) {
        return (<span/>);
    }

    const option = options.data.find((o) => o['@id'] === campaign[field]);

    if (!option) {
        return (<span/>);
    }

    return (
        <CampaignInput>
            <FormControl>
                <Typography variant={'caption'} component={'div'}>{label}</Typography>
                <Typography variant={'body2'} component={'div'} style={{marginTop: '8px'}}>{option[optionText]}</Typography>
            </FormControl>
        </CampaignInput>
    );
};

CampaignReferenceField.propTypes = {
    field: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    options: PropTypes.object,
    optionText: PropTypes.string,
};

const mapStateToProps = state => ({
    campaign: campaignSelectCampaign(state)
});

export default connect(mapStateToProps, null)(CampaignReferenceField);